import { render, staticRenderFns } from "./ProductVariation.vue?vue&type=template&id=2331b714&scoped=true"
import script from "./ProductVariation.vue?vue&type=script&lang=js"
export * from "./ProductVariation.vue?vue&type=script&lang=js"
import style0 from "./ProductVariation.vue?vue&type=style&index=0&id=2331b714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2331b714",
  null
  
)

export default component.exports